module.exports = __webpack_public_path__ + "img/rpg-logo.83a01a83.png";